<div style="height: fit-content; max-height: 100%; width: 100%; position: relative" [hidden]="!showBox ? showBoxClicked() : false">
  <div [ngClass]="!useFixedPosition ? 'container-standard' : 'container-fixed'">
    <div class="form-div" *ngIf="showSearchField">
      <div class="search-bar">
        <input class="search-bar-input" #inputField placeholder="Search" (input)="onInputChange(inputField.value)" />
        <img src="https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/magnifier.svg" class="form-img" />
      </div>
    </div>
    <div class="line"></div>
    <div class="top-bottom-padding" [ngStyle]="{ 'max-height': maxHeight - 43 + 'px' }">
      <div [hidden]="list.length < 1">
        <label class="header" [hidden]="isTyping" *ngIf="showHeaders">ALPHABETICAL</label>
        <div class="spacer" *ngIf="showHeaders"></div>
        <div class="items-container">
          <div *ngFor="let item of displayedList">
            <div class="divider" *ngIf="showDivider(item)"></div>
            <div [ngClass]="item.value !== 'search-box-title' ? 'hovering-item' : 'item-container'">
              <div [ngClass]="item.value !== 'search-box-title' ? 'item' : 'title-item'" (click)="onItemClicked(item)">
                <ng-container *ngIf="checkSelectedItems(item) && checkboxType === 'square' && !isItemDisabled(item.label) && item.value !== 'search-box-title'">
                  <img class="img" [src]="iconService.Icon.checkbox_tick" />
                </ng-container>
                <ng-container *ngIf="!checkSelectedItems(item) && checkboxType === 'square' && !isItemDisabled(item.label) && item.value !== 'search-box-title'">
                  <img class="img" [src]="iconService.Icon.checkbox_grey_empty" />
                </ng-container>
                <ng-container *ngIf="!checkSelectedItems(item) && checkboxType === 'square' && isItemDisabled(item.label) && item.value !== 'search-box-title'">
                  <img class="img" [src]="iconService.Icon.checkbox_disabled" />
                </ng-container>
                <ng-container *ngIf="checkSelectedItems(item) && checkboxType === 'circle' && !isItemDisabled(item.label) && item.value !== 'search-box-title'">
                  <img class="img" [src]="iconService.Icon.round_checkbox_grey_tick" />
                </ng-container>
                <ng-container *ngIf="!checkSelectedItems(item) && checkboxType === 'circle' && !isItemDisabled(item.label) && item.value !== 'search-box-title'">
                  <img class="img" [src]="iconService.Icon.round_checkbox_grey_empty" />
                </ng-container>
                <ng-container *ngIf="!checkSelectedItems(item) && checkboxType === 'circle' && isItemDisabled(item.label) && item.value !== 'search-box-title'">
                  <img class="img" [src]="iconService.Icon.round_checkbox_grey_disabled" />
                </ng-container>
                <label *ngIf="item.value === 'search-box-title'" [matTooltip]="item?.label" [matTooltipDisabled]="!withHoverEffect" class="title">{{ item.label }}:</label>
                <img [src]="item.value" *ngIf="item.label !== 'search-box-title' && hasIcons" class="img" />
                <label
                  [ngClass]="item?.label === currentValue?.label ? 'item-text-bold' : 'item-text'"
                  [matTooltip]="item?.label"
                  [matTooltipDisabled]="!withHoverEffect"
                  [ngStyle]="{ color: isItemDisabled(item.label) ? '#A6A6A6' : '#222222' }"
                  class="disable-selection"
                  *ngIf="item.value !== 'search-box-title'">
                  {{ item.label }}
                </label>
              </div>
              <ng-container *ngIf="checkSelectedItems(item)">
                <img class="img" [src]="iconService.Icon.check" />
              </ng-container>
            </div>
          </div>
          <div class="no-result-text" *ngIf="displayedList.length === 0">No results</div>
        </div>
      </div>
    </div>
  </div>
</div>
